module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DataImportBase', {
    attrs: {
      "title": '標籤藥物儲存',
      "uploadUrl": '/upload-tag-drug-storage-table/',
      "downloadUrl": '/export-tag-drug-storage-table/'
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05370598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/DataImport/TagDrugStorageImport.vue
// module id = 1370
// module chunks = 1